import React, { FormEvent } from 'react';
import {
  Button,
  InputAdornment,
  Typography,
  Box,
  TextField,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import useAlias from '@hooks/useAlias';
import {
  useDataPointSearchState,
  useDataPointSearchActions,
} from '../context/DataPointSearchContext';
import {
  searchSectionSx,
  ActiveSearchIndicator,
  searchFormSx,
  searchButtonSx,
} from '../DataPointSearch.styles';

const SearchBar: React.FC = () => {
  const alias = useAlias();
  const state = useDataPointSearchState();
  const { setSearchText, submitSearch, clearSearch } =
    useDataPointSearchActions();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    submitSearch();
  };

  const handleClear = () => {
    clearSearch();
  };

  const showClearButton = state.searchText || state.activeSearch;

  return (
    <Box sx={searchSectionSx}>
      <Box component='form' onSubmit={handleSubmit} sx={searchFormSx}>
        <TextField
          fullWidth
          size='small'
          placeholder={alias('Search across all fields...')}
          value={state.searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <Button type='submit' variant='outlined' sx={searchButtonSx}>
          {alias('Search')}
        </Button>
        {showClearButton && (
          <Button
            onClick={handleClear}
            variant='outlined'
            startIcon={<ClearIcon />}
            sx={searchButtonSx}
          >
            {alias('Clear')}
          </Button>
        )}
      </Box>

      {state.activeSearch && (
        <ActiveSearchIndicator>
          <SearchIcon fontSize='inherit' />
          <Typography variant='caption'>
            {alias('Searching for')}: {state.activeSearch}
          </Typography>
        </ActiveSearchIndicator>
      )}
    </Box>
  );
};

export default SearchBar;
